import {Component, OnInit} from '@angular/core';
import {UIService} from "@/_services/ui.service";
import {AbstractEditEnvironmentsComponent} from "@/_components/characteristic-management/environment-editing/abstract-edit-environments.component";
import {DragulaService} from "ng2-dragula";

@Component({
    selector: 'app-environment-metabolisms',
    templateUrl: './environments-edit.html',
    styleUrls: ["../../_forms/forms.css", "../../dragula.css"]
})

export class EnvironmentsEditPropertiesComponent extends AbstractEditEnvironmentsComponent implements OnInit{
    EnvironmentTypeName="properties";

    constructor(
        protected dragula:DragulaService,
        protected tooltipService : UIService
    ) {
        super();
    }

    ngOnInit() {
        this.Init(this.tooltipService.GetPropertyEnvironments());
    }

    protected SubmitRequestToServer(): Promise<void> {
        return super.ProcessServerRequest(this.tooltipService.UpdatePropertyEnvironments(this.Environments));
    }
}

